import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { DiscountCountdownInterface } from '../../shared/interfaces/discount-countdown-interface';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/lib/services/platform-information.service';
import { delayedRetry } from '../../../../projects/platform-manager/src/lib/services/DEFAULT_MAX_RETRIES';
import { MulticastObserverFactoryService } from './multicast-observer-factory.service';

@Injectable({
  providedIn: 'root'
})
export class DiscountTickerService {
  public discounts$: Observable<Array<DiscountCountdownInterface>>;
  private discounts: Array<DiscountCountdownInterface>; // cache for discounts

  constructor(
    private client: HttpClient,
    private platform: PlatformInformationService,
    multicastObservableFactory: MulticastObserverFactoryService
  ) {
    this.discounts$ = multicastObservableFactory.create<Array<DiscountCountdownInterface>>(
      this.loadDiscountData
    );
  }

  /**
   * function for factory to load discount tickers
   */
  private loadDiscountData = (observer?) => {
    if (this.discounts) {
      observer.next(this.discounts);
      observer.complete();
    } else {
      this.getDiscounts().subscribe({
        next: data => {
          this.discounts = data;
          observer.next(this.discounts);
          observer.complete();
        },
        error: e => {
          console.error(e);
          observer.next([]);
          observer.complete();
        }
      });
    }
  };

  private getDiscounts(): Observable<Array<DiscountCountdownInterface>> {
    // if you want to quickly test the discount ticker, use this
    // return of([
    //   {
    //     companyId: 4,
    //     until: '2024-11-10T00:00:00+0000',
    //     timestamp: (Date.now() / 1000 + 45).toString(), //"1800000000",
    //     showToLocals: true,
    //     excludeMerchantIds: '',
    //     excludeCountryCodes: ''
    //   }
    // ]);
    const url = this.platform
      .getApiEndpointFor('getDiscountCountdowns')
      .replace('%lang%', this.platform.getDefaultLangForPlatform());

    return this.client
      .get<Array<DiscountCountdownInterface>>(url, { headers: { Accept: 'application/json' } })
      .pipe(
        delayedRetry(3000),
        catchError(() => {
          return throwError(() => new Error('Could not load discounts data: ' + url));
        })
      );
  }
}
